module.exports = __webpack_public_path__ + "home_driverless_2.59b79266201038ca8d5f.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/home_driverless_2.png
// module id = ../../../../../src/assets/img/home_driverless_2.png
// module chunks = styles